// Constants for the user-auth directives module

export default Object.freeze({
    module_name: "trackerbase-app.directives.user-auth"
});



//////////////////
// WEBPACK FOOTER
// ./src/directives/user-auth/ModuleConstants.js
// module id = XABH
// module chunks = 1